import React from 'react'

import is from '../assets/is.png'
import en from '../assets/en.png'
import { useTranslation } from 'react-i18next'

const SelectLanguage = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
): React.ReactElement => {
  const { i18n } = useTranslation()

  const setLang = (e: React.MouseEvent, lng: string) => {
    e.preventDefault()
    i18n.changeLanguage(lng)
  }

  return (
    <div {...props}>
      <a href="#is" onClick={(e) => setLang(e, 'is')} className="mr-1">
        <img src={is} alt="Íslenska" />
      </a>
      <a href="#en" onClick={(e) => setLang(e, 'en')}>
        <img src={en} alt="English" />
      </a>
    </div>
  )
}

export default SelectLanguage
